/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Mcp_1_TitleInputs */

const en_vc_mcp_1_title = /** @type {(inputs: Vc_Mcp_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe it, get vector art`)
};

const zh_vc_mcp_1_title = /** @type {(inputs: Vc_Mcp_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`说出想法，得到矢量图`)
};

/**
* | output |
* | --- |
* | "Describe it, get vector art" |
*
* @param {Vc_Mcp_1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_mcp_1_title = /** @type {((inputs?: Vc_Mcp_1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Mcp_1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_mcp_1_title(inputs)
	return zh_vc_mcp_1_title(inputs)
});
export { vc_mcp_1_title as "vc.mcp.1.title" }